import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import A1 from "../../Assets/SafetyClassImages/A1.svg";
import A2 from "../../Assets/SafetyClassImages/A2.svg";
import A2L from "../../Assets/SafetyClassImages/A2L.svg";
import A3 from "../../Assets/SafetyClassImages/A3.svg";
import B1 from "../../Assets/SafetyClassImages/B1.svg";
import B2 from "../../Assets/SafetyClassImages/B2.svg";
import B2L from "../../Assets/SafetyClassImages/B2L.svg";
import B3 from "../../Assets/SafetyClassImages/B3.svg";
import "./SafetyClass.css";
import { Box } from '@mui/material';

const SafetyClassBox = ({
    safetyClass,
}) => {
    const [config, setConfig] = useState({
        Color1: "#FFF",
        Color2: "#FFF",
        TextColor: "#000",
        Text: "",
        Icon: A1,
    });
    
    const getSafetyConfig = (safetyClass) => {
        const A1Config = {
            Color1: "#CCDB38",
            Color2: "#FFEB3A",
            TextColor: "#000",
            Text: "A1",
            Icon : A1
        };
        const A2Config = {
            Color1: "#FF9700",
            Color2: "#FFEB3A",
            TextColor: "#FFF",
            Text: "A2",
            Icon: A2
        };
        const A2LConfig = {
            Color1: "#CCDB38",
            Color2: "#FFEB3A",
            TextColor: "#000",
            Text: "A2L",
            Icon: A2L
        };
        const A3Config = {
            Color1: "#F34135",
            Color2: "#CCDB38",
            TextColor: "#FFF",
            Text: "A3",
            Icon: A3
        };
        const B1Config = {
            Color1: "#CCDB38",
            Color2: "#F34135",
            TextColor: "#000",
            Text: "B1",
            Icon: B1
        };
        const B2Config = {
            Color1: "#CCDB38",
            Color2: "#FFEB3A",
            TextColor: "#000",
            Text: "B2",
            Icon: B2
        };
        const B2LConfig = {
            Color1: "#FFEB3A",
            Color2: "#F34135",
            TextColor: "#000",
            Text: "B2L",
            Icon: B2L
        };
        const B3Config = {
            Color1: "#F34135",
            Color2: "#F34135",
            TextColor: "#FFF",
            Text: "B3",
            Icon: B3
        };

        switch (safetyClass) {
            case "A1":
                setConfig(A1Config);
                break;
            case "A2":
                setConfig(A2Config);
                break;
            case "A2L":
                setConfig(A2LConfig);
                break;
            case "A3":
                setConfig(A3Config);
                break;
            case "B1":
                setConfig(B1Config);
                break;
            case "B2":
                setConfig(B2Config);
                break;
            case "B2L":
                setConfig(B2LConfig);
                break;
            case "B3":
                setConfig(B3Config);
                break;
            default:
                break;
        };
    };

    useEffect(() => {
        getSafetyConfig(safetyClass);
    }, []);

    return (
        <Box
            className="SafetyContainer flex"
            sx={{
                padding: { xs: '20px', md: '8px', lg: '20px'},
                background: `linear-gradient(45deg, ${config.Color1}, ${config.Color2})`,
                boxSizing: 'border-box',
                marginTop: { md: '0 !important', lg: '6% !important'}
            }}
        >
            <p
                className="SafetyText"
                style={{ color: config.TextColor}}
            >
                Safety Class : {config.Text}
            </p>
            <img src={config.Icon} alt="Safety Class"/>
        </Box>
    );
};

SafetyClassBox.propTypes = {
    safetyClass: PropTypes.string.isRequired,
};

export default SafetyClassBox;
